
    // this file was auto generated by python script
    import Box from './Box';
    export default Box;
    